import React from "react";

interface PublicLayoutProps {
  children?: any;
}

const PublicLayout: React.FC<PublicLayoutProps> = (props) => {
  return <>{props.children}</>;
};

export default PublicLayout;
